/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetExperimentFilePathParams = NonNullable<
  operations['internalGetExperimentFile']['parameters']['path']
>;

export interface Input extends InternalGetExperimentFilePathParams {
  apiVersion?: string;
  header: NonNullable<operations['internalGetExperimentFile']['parameters']['header']>;
}

export async function internalGetExperimentFile(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/files/{fileId}',
    {
      params: { path, header },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
